import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-title',
		defaultMessage: 'Create a field',
		description: 'Section heading to create a new custom field',
	},
	description: {
		id: 'project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-description',
		defaultMessage:
			'Drag a field type to one of the sections on the left to create a custom field for this issue type.',
		description: 'Section description to create a new custom field',
	},
	descriptionIssueTermRefresh: {
		id: 'project-settings-apps.issue-type-page.fields.fields-toolbar.create-field-description-issue-term-refresh',
		defaultMessage:
			'Drag a field type to one of the sections on the left to create a custom field for this work type.',
		description: 'Section description to create a new custom field',
	},
	fieldCreationLimitReached: {
		id: 'project-settings-apps.issue-type-page.fields.fields-toolbar.field-creation-limit-reached',
		defaultMessage:
			'You can’t create more than {fieldLimit} fields in this project. You can reuse previously created fields.',
		description:
			'Message displayed in the right toolbar when the user has reached the maximum number of fields they can create for a project',
	},
});

export default messages;
